import { render, staticRenderFns } from "./OrderPurchaseEdit.vue?vue&type=template&id=6704010a&scoped=true"
import script from "./OrderPurchaseEdit.vue?vue&type=script&lang=js"
export * from "./OrderPurchaseEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderPurchaseEdit.vue?vue&type=style&index=0&id=6704010a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704010a",
  null
  
)

export default component.exports